import React from "react"
import Link from 'gatsby-link'

export default function NextStaticPage (props){
    return(
    
        <Link className="next-static-page" to={`/${props.to}/`}>
        {props.text}
        </Link>
    );
}



// WEBPACK FOOTER //
// ./src/components/Linking/nextStaticPage.js